/* eslint-disable @typescript-eslint/naming-convention */
import { MeterDetailOther } from '@enmon/commons/lib/enmon';
import { OtherMeterDetailField } from 'components/Form/meter_details/other/constants';
import { OtherDetails } from 'components/Form/meter_details/other/OtherDetails';
import { VFC } from 'react';

export type MeterOtherDetails = MeterDetailOther;

export type MeterOtherDetailsProps = MeterOtherDetails;

export const OtherMeterDetails: VFC<MeterOtherDetailsProps> = props => {
  const { deviceCategory } = props;

  return (
    <OtherDetails
      itemsConfig={{
        [OtherMeterDetailField.DeviceCategory]: {
          formItemProps: { initialValue: deviceCategory },
        },
      }}
    />
  );
};
